import ParamTitle from "./paramtitle.js";
import ParamCheckBox from "./paramcheckbox.js";
import ParamSlider from "./paramslider.js";
import { configurations_getDefaultTimeLineParams } from "../../../../../utils/configurations.js";
import "./tabs.css"
import React from "react";

class TimeLineTab extends React.Component
{

    constructor(props)
    {
        super(props);
        this.onchange = this.onchange.bind(this);

        var defaultconf = configurations_getDefaultTimeLineParams();
        if (!("displayCpArea" in this.props.timelineparams))
            this.props.timelineparams.displayCpArea = defaultconf.displayCpArea;
        if (!("magnetism" in this.props.timelineparams))
            this.props.timelineparams.magnetism = defaultconf.magnetism;
        if (!("displayFrame" in this.props.timelineparams))
            this.props.timelineparams.displayFrame = defaultconf.displayFrame;

    }

    componentDidMount()
    {}
    componentWillUnmount()
    {}

    onchange (paramnumber, value)
    {

        
        switch (paramnumber)
        {
            case 0: // affichage des zones avant cp
                this.props.timelineparams.displayCpArea = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;
            case 1: // magnetism
                this.props.timelineparams.magnetism = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;
            case 2: // displayframe
                this.props.timelineparams.displayFrame = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;

            case 3: // display track audio tr
                this.props.timelineparams.trtrackaudio = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;

            case 4: // display track audio tr small
                this.props.timelineparams.trsmalltrackaudio = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;


            case 5: // display track cp tr
                this.props.timelineparams.trtrackcp = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;

            case 6: // display track cp small tr
                this.props.timelineparams.trsmalltrackcp = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;
                
            case 7: // display original transcript tr
                this.props.timelineparams.troriginaltr = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;

            case 8: // display corrected transcript tr
                this.props.timelineparams.trcorrectedtr = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;


            case 9: // display track audio st
                this.props.timelineparams.sttrackaudio = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;

            case 10: // display track audio st small
                this.props.timelineparams.stsmalltrackaudio = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;


            case 11: // display track cp st
                this.props.timelineparams.sttrackcp = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;

            case 12: // display track cp small st
                this.props.timelineparams.stsmalltrackcp = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;

            case 13: // display original transcript st
                this.props.timelineparams.storiginaltr = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;

            case 14: // display corrected transcript st
                this.props.timelineparams.stcorrectedtr = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;

            case 15: // display original st
                this.props.timelineparams.storiginalst = value;
                this.props.onchange({type:"timeline", value: this.props.timelineparams});
                break;


        }
    }

    render()
    {
        return(<>
        <div className="tabsettingsFullTab">
            <div className="tabsettingsTitleTab">
                {this.props.title}
                <br/><br/>
            </div>
            <div className="tabsettingscontentdata">
                <div className="tabsettingscontentdataScrollable">
                <ParamTitle
                    text = {{cat:7, scat:7}}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {0}
                    id = "TI01"
                    text ={{cat:7,scat:8}}
                    value = {this.props.timelineparams.displayCpArea}
                    />

                <ParamTitle
                    text = {{cat:7, scat:9}}
                    />

                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {1}
                    key ="sliderMagnetism"
                    text ={{cat:7,scat:10}}
                    value = {this.props.timelineparams.magnetism}
                    min = {0}
                    max ={10}
                    unit = "i" />

                <br/>

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {2}
                    id = "TI02"
                    text ={{cat:7,scat:11}}
                    value = {this.props.timelineparams.displayFrame}
                    />


                
                <ParamTitle
                    text = {{cat:7, scat:12}}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {3}
                    id = "TIAUD1"
                    text ={{cat:7,scat:14}}
                    value = {this.props.timelineparams.trtrackaudio}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {4}
                    id = "TIAUD2"
                    text ={{cat:7,scat:15}}
                    value = {this.props.timelineparams.trsmalltrackaudio}
                    />
                
                <br/>
                
                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {5}
                    id = "TICP1"
                    text ={{cat:7,scat:16}}
                    value = {this.props.timelineparams.trtrackcp}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {6}
                    id = "TICP2"
                    text ={{cat:7,scat:17}}
                    value = {this.props.timelineparams.trsmalltrackcp}
                    />

                <br/>
                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {7}
                    id = "TITR1"
                    text ={{cat:7,scat:18}}
                    value = {this.props.timelineparams.troriginaltr}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {8}
                    id = "TITR2"
                    text ={{cat:7,scat:19}}
                    value = {this.props.timelineparams.trcorrectedtr}
                    />



                <ParamTitle
                    text = {{cat:7, scat:13}}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {9}
                    id = "TIAUD3"
                    text ={{cat:7,scat:14}}
                    value = {this.props.timelineparams.sttrackaudio}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {10}
                    id = "TIAUD4"
                    text ={{cat:7,scat:15}}
                    value = {this.props.timelineparams.stsmalltrackaudio}
                    />
                <br/>
                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {11}
                    id = "TICP3"
                    text ={{cat:7,scat:16}}
                    value = {this.props.timelineparams.sttrackcp}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {12}
                    id = "TICP4"
                    text ={{cat:7,scat:17}}
                    value = {this.props.timelineparams.stsmalltrackcp}
                    />

                <br/>
                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {13}
                    id = "TITR3"
                    text ={{cat:7,scat:18}}
                    value = {this.props.timelineparams.storiginaltr}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {14}
                    id = "TITR4"
                    text ={{cat:7,scat:19}}
                    value = {this.props.timelineparams.stcorrectedtr}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {15}
                    id = "TIST1"
                    text ={{cat:7,scat:20}}
                    value = {this.props.timelineparams.storiginalst}
                    />


        </div>
        </div>
            
        </div>
        </>
        )
    }

}

export default TimeLineTab